function isMobile() {
    return typeof window !== "undefined" ? $(window).width() <= 576 : true;
}

export default isMobile;
